// extracted by mini-css-extract-plugin
export default {"container":"SwiperComp_container__D2irI","myswiper":"SwiperComp_myswiper__Qq0h5","swiperslide":"SwiperComp_swiperslide__d5pNP"};